import { useEffect, useState } from 'react';

import apiOffers from 'api/offers';

export interface IOfferDepartment {
  id: number;
  name: string;
}

// Read once while the app is open
let cached: IOfferDepartment[] | null = null;

/** The departments whose offers the user can see, in the order of their names. */
const useOfferDepartments = (): IOfferDepartment[] => {
  const [departments, setDepartments] = useState<IOfferDepartment[]>(
    cached ?? []
  );

  useEffect(() => {
    if (cached !== null) {
      return undefined;
    }

    let active = true;
    apiOffers.departments
      .get()
      .then((loaded) => {
        cached = loaded;
        if (active) {
          setDepartments(loaded);
        }
      })
      .catch(() => undefined);

    return () => {
      active = false;
    };
  }, []);

  return departments;
};

export default useOfferDepartments;
